// Read-only navigation. Never infer an edge from a cluster, a name or proximity.
export const normalizeName = value => String(value || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase('fr');
export function neighbourhood(graph, id, depth = 1) {
  const found = new Set(graph.hasNode(id) ? [id] : []);
  let frontier = [...found];
  for (let i = 0; i < depth; i++) {
    const next = [];
    for (const node of frontier) for (const other of graph.neighbors(node)) if (!found.has(other)) { found.add(other); next.push(other); }
    frontier = next;
  }
  return found;
}
export function navigationGroups(graph, communities = []) {
  // Split community output into connected subsets: even a computed community is
  // never presented as a connected group unless the actual edges support it.
  const assignment = new Map();
  for (const g of communities) for (const id of g.members) assignment.set(id, g.id ?? g.members[0]);
  const seen = new Set(), groups = [];
  for (const id of graph.nodes()) {
    if (seen.has(id) || !graph.degree(id)) continue;
    const members = [id]; seen.add(id);
    for (let i = 0; i < members.length; i++) for (const other of graph.neighbors(members[i])) {
      if (!seen.has(other) && assignment.get(other) === assignment.get(id)) { seen.add(other); members.push(other); }
    }
    // A singleton partition is still included: its external documented links
    // remain accessible from the person inspector and neighbourhood expansion.
    groups.push({ id: members.reduce((a,b)=>a<b?a:b), members });
  }
  for (const group of groups) {
    group.members.sort((a,b)=>graph.neighbors(b).length-graph.neighbors(a).length || a.localeCompare(b));
    group.names = group.members.slice(0,2).map(id=>graph.getNodeAttribute(id,'label'));
    const inside = new Set(group.members);
    group.edges = group.members.reduce((n,id)=>n+graph.edges(id).filter(e=>graph.extremities(e).every(v=>inside.has(v))).length,0)/2;
  }
  return groups.sort((a,b)=>b.members.length-a.members.length || a.id.localeCompare(b.id));
}
export function directoryRows(graph, {query='', scope='ALL', domain='ALL'} = {}) {
  const q = normalizeName(query);
  return graph.filterNodes((id,a)=> (!q || normalizeName(a.label).includes(q) || normalizeName(id)===q)
    && (scope==='ALL' || (scope==='UNLINKED' ? !graph.degree(id) : graph.degree(id)>0))
    && (domain==='ALL' || a.careerDomains?.includes(domain) || a.domain===domain))
    .sort((a,b)=>graph.getNodeAttribute(a,'label').localeCompare(graph.getNodeAttribute(b,'label'),'fr') || a.localeCompare(b));
}
